"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMeasure = void 0;
/**
 * @summary Checks if an item is a `Measure`.
 *
 * Checks if an item is a `Measure`. For the check to succeed, the item must be
 * an object with a string-typed `unit`. If the item has a value, it must be of
 * type number.
 *
 * @param {any} item
 * @returns {boolean}
 *
 * @example
 * if (isMeasure(value)) {
 *   // ...
 * }
 */
function isMeasure(item) {
    return (item != null &&
        typeof item === 'object' &&
        (!('value' in item) ||
            ('value' in item &&
                (item.value == null || typeof item.value === 'number'))) &&
        typeof item.unit === 'string');
}
exports.isMeasure = isMeasure;
